export default {
	hello: "Hello in de",
	languageSelector: "Sélecteur de langue"
}
